<template>
  <div class="field has-addons searchcontainer">
    <div class="control">
      <input
        class="input search"
        v-model="searchVal"
        placeholder="Search"
        @keyup.esc="clearSearch"
        @keyup.delete="updateSearch"
        @keypress="updateSearch"
      />
      <button class="button is-transparent is-inline is-text" @click="updateSearch">
        <span class="is-sr-only">Search</span>
        <span class="icon">
          <img aria-hidden="true" alt src="/dist/assets/icons/arrow-right-yellow.svg" />
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    namespace: String
  },
  data () {
    return {
      searchVal: ''
    }
  },
  methods: {
    updateSearch () {
      this.$store.commit(this.namespace + '/UPDATE_SEARCH', this.searchVal)
    },
    clearSearch () {
      console.log('foo')
      this.searchVal = ''
      this.updateSearch()
    }
  },
  computed: {
    search () {
      return this.$store.state[this.namespace].search
    }
  },
  watch: {
    search: function () {
      this.searchVal = this.search
    }
  }
}
</script>
